import { useEffect, useState } from "react";
import { getConfig } from "@fm/api";
import type { RenterDriversConfig } from "@fm/api";
import { getApiBaseUrl } from "../../lib/config";

/**
 * The fleet's `renter_drivers` config (FLEE-442): whether the booking site
 * asks for drivers and how many additional ones fit. `undefined` until it
 * loads, and when the response has no such key (a flag-off server), so the
 * section stays hidden by default.
 */
export function useRenterDriversConfig(
  apiKey: string | undefined,
  apiBaseUrl?: string,
): RenterDriversConfig | undefined {
  const [config, setConfig] = useState<RenterDriversConfig | undefined>();

  useEffect(() => {
    if (!apiKey) return;

    let cancelled = false;
    getConfig({ baseUrl: getApiBaseUrl(apiBaseUrl), apiKey })
      .then((response) => {
        if (!cancelled) setConfig(response?.renter_drivers);
      })
      .catch(() => {
        // EmbedProvider already reports a config failure; stay hidden here.
      });

    return () => {
      cancelled = true;
    };
  }, [apiKey, apiBaseUrl]);

  return config;
}
